module.exports = __webpack_public_path__ + "img/unstabilized_concreted.2a78e58e.png";